module.exports = __webpack_public_path__ + "static/img/14.b4f4f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/14.png
// module id = Sal/
// module chunks = 35